export const formatInternalTicketProtocol = (internalTicket) => {
  if (!internalTicket?.id || !internalTicket?.createdAt) return "-";

  const date = new Date(internalTicket.createdAt);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);

  return `INT-${day}${month}${year}-${internalTicket.id}`;
};

export const getInternalTicketPriorityLabel = (priority) => {
  const labels = {
    low: "Baixa",
    medium: "Media",
    high: "Alta",
    urgent: "Urgente"
  };

  return labels[priority] || priority || "-";
};

export const getInternalTicketStatusLabel = (status) => {
  const labels = {
    open: "Aberto",
    in_progress: "Em andamento",
    waiting: "Aguardando terceiro",
    done: "Concluido",
    cancelled: "Cancelado"
  };

  return labels[status] || status || "-";
};

export const getInternalTicketSlaLabel = (slaStatus) => {
  const labels = {
    unscheduled: "Sem SLA",
    on_time: "No prazo",
    due_soon: "Vence em breve",
    overdue: "Vencido",
    completed: "Concluido"
  };

  return labels[slaStatus] || slaStatus || "-";
};
